// Default product image shown for every product (brand logo), old and new.
// Static asset in frontend/public — ships with the build, works in preview and production.
export const DEFAULT_PRODUCT_IMAGE = "/product-logo.png";
